// 保持你的导入路径：从utils目录导入request
import request from '../utils/request'

// 1. 管理员订单分页查询（后端：GET /order/admin/page）
export const adminOrderPage = (params) => {
  const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
  return request({
    url: '/api/order/admin/page', // 与后端路径完全一致
    method: 'GET',
    params: {
      pageNum: 1, // 后端默认值，前端显式传递
      pageSize: 10, // 后端默认值
      userRole: userInfo.role || '',
      ...params // 合并搜索条件（如piNo、customerNo、poNo）
    }
  })
}

// 2. 管理员订单删除（后端：POST /order/admin/delete）
export const adminDeleteOrder = (id) => {
  return request({
    url: '/api/order/admin/delete', // 与后端路径完全一致
    method: 'POST',
    params: { id } // 后端@RequestParam接收id，参数传递正确
  })
}

// 3. 管理员订单编辑回显（后端：GET /order/admin/getById）
export const adminGetOrderById = (id) => {
  return request({
    url: '/api/order/admin/getById', // 与后端路径完全一致
    method: 'GET',
    params: { id } // 后端@RequestParam接收id，正确
  })
}

// 4. 客户订单分页查询（按现有结构保留，需后端对应接口支持）
export const customerOrderPage = (params) => {
  return request({
    url: '/api/order/customer/page',
    method: 'GET',
    params: {
      pageNum: 1, // 新增默认参数，避免后端参数缺失
      pageSize: 10,
      ...params
    }
  })
}

// 5. 订单新增/编辑（后端：POST /order/admin/saveOrUpdate）
export const saveOrUpdateOrder = (orderForm) => {
  return request({
    url: '/api/order/admin/saveOrUpdate', // 修正路径：新增/admin，与后端一致
    method: 'POST',
    data: orderForm // 后端@RequestBody接收，传递正确
  })
}

// 6. 批量更新状态（后端：POST /order/admin/batchUpdateStatus）
export const batchUpdateStatus = (statusList) => {
  return request({
    url: '/api/order/admin/batchUpdateStatus', // 修正路径：与后端完全一致
    method: 'POST',
    data: statusList // 后端@RequestBody接收List<Status>，正确
  })
}

// 7. 订单导入（按现有结构保留，需后端对应接口支持）
export const importOrders = (file) => {
  const formData = new FormData()
  formData.append('file', file)
  return request({
    url: '/api/order/import',
    method: 'POST',
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' }, // 文件上传格式正确
    timeout: 30000 // 新增超时时间，避免大文件上传超时
  })
}

// 8. 管理员订单列表查询（后端：GET /order/admin/list）
export const adminOrderList = (params) => {
  return request({
    url: '/api/order/admin/list', // 与后端路径完全一致
    method: 'GET',
    params: {
      piNo: '', // 可选搜索参数，默认空
      customerNo: '', // 可选搜索参数，默认空
      ...params
    }
  })
}

// 9. 订单状态分页查询（后端：GET /order/admin/status）
export const getOrderStatusPage = (params) => {
  return request({
    url: '/api/order/admin/status', // 修正路径：与后端完全一致
    method: 'GET',
    params: {
      pageNum: 1, // 后端默认值
      pageSize: 10, // 后端默认值
      piNo: '', // 可选搜索参数
      ...params
    }
  })
}